import { Button, Heading, HFlow, Tag, Text, Tooltip, VFlow } from 'bold-ui'
import { useAlert } from 'components/alert'
import { Box } from 'components/Box'
import { useErrorHandler } from 'components/error'
import {
  useDesabilitarPainelChamadasMutation,
  useHabilitarPainelChamadasMutation,
  useIsPainelChamadasHabilitadoQuery,
} from 'graphql/hooks.generated'
import { PermissaoPainelChamadas } from 'view/chamada-painel/model-chamadaPainel'

interface HabilitarPainelChamadasBoxProps {
  unidadeSaudeId: ID
  isButtonDisabled: boolean
  permissao: PermissaoPainelChamadas
}

export const HabilitarPainelChamadasBox = (props: Readonly<HabilitarPainelChamadasBoxProps>) => {
  const { unidadeSaudeId, isButtonDisabled, permissao } = props

  const { data, refetch, loading: isLoadingCheckHabilitado } = useIsPainelChamadasHabilitadoQuery({
    variables: { unidadeSaudeId },
  })

  const [habilitarPainelChamadas, { loading: isLoadingHabilitar }] = useHabilitarPainelChamadasMutation()
  const [desabilitarPainelChamadas, { loading: isLoadingDesabilitar }] = useDesabilitarPainelChamadasMutation()
  const handleRejection = useErrorHandler()
  const alert = useAlert()

  const habilitado = data?.isPainelChamadasHabilitado ?? false
  const isLoading = isLoadingHabilitar || isLoadingDesabilitar || isLoadingCheckHabilitado

  const handleHabilitar = () => {
    habilitarPainelChamadas({ variables: { unidadeSaudeId } })
      .then(() => {
        alert('success', 'Painel de chamadas habilitado com sucesso.')
        refetch()
      })
      .catch(handleRejection)
  }

  const handleDesabilitar = () => {
    desabilitarPainelChamadas({ variables: { unidadeSaudeId } })
      .then(() => {
        alert('success', 'Painel de chamadas desabilitado com sucesso.')
        refetch()
      })
      .catch(handleRejection)
  }

  const tooltipText = () => {
    if (!permissao.enabled) return permissao.hint ?? undefined
    if (isButtonDisabled)
      return 'Para habilitar o painel, configure um dispositivo e cadastre as salas disponíveis na sua unidade'
    return undefined
  }

  return (
    <Box>
      <VFlow>
        <HFlow justifyContent='space-between'>
          <Heading level={3}>Habilitar painel de chamadas</Heading>
          {habilitado ? (
            <Tag type='success' icon='checkCircleFilled'>
              Habilitado
            </Tag>
          ) : (
            <Tag type='normal' icon='banOutline'>
              Desabilitado
            </Tag>
          )}
        </HFlow>
        <Text>
          Para habilitar o painel de chamadas, confira se as salas foram cadastradas, o dispositivo está vinculado e o
          painel foi iniciado no dispositivo.
        </Text>
        <Tooltip text={tooltipText()}>
          <Button
            kind={habilitado ? 'normal' : 'primary'}
            size='small'
            onClick={habilitado ? handleDesabilitar : handleHabilitar}
            disabled={isButtonDisabled || !permissao.enabled}
            loading={isLoading}
          >
            {habilitado ? 'Desabilitar' : 'Habilitar'}
          </Button>
        </Tooltip>
      </VFlow>
    </Box>
  )
}
